export default {
      id: "i_button-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#i_button-usage",
      toString: function () {
        return this.url;
      }
    }